import { call, put, take, select } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import api from '../api/api'
import {
  FETCH_GRADES_REQUEST,
  FETCH_GRADES_SUCCESS,
  FETCH_GRADES_FAIL,
} from '../actions/actions'
import { statusCodeIsBelow400 } from '../helpers/utility'

export function* fetchGrades() {
  while (true) {
    const actionData = yield take(FETCH_GRADES_REQUEST)

    // read from cache if not forced to re-load
    const currentGrades = yield select(state => state.grades)

    if (!actionData.force && currentGrades.length > 0) {
      yield put({
        type: FETCH_GRADES_SUCCESS,
        courseTopics: currentGrades,
        meta: {
          fromCache: true,
        },
      })

      return
    }

    // TODO: start the loading

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors },
        },
      } = yield call(fetchGradesApiCall)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_GRADES_SUCCESS,
          grades: data.grades,
        })
      } else {
        yield put({
          type: FETCH_GRADES_FAIL,
          error: general_errors,
        })
      }
    } catch (error) {
      yield put({
        type: FETCH_GRADES_FAIL,
        error,
      })
    }
  }
}

function* fetchGradesApiCall(token) {
  // retry 3 times
  for (let i = 0; i < 3; i++) {
    try {
      const response = yield call(api.fetchGrades, token)
      return response
    } catch (error) {
      if (i < 2) {
        yield call(delay, 1000) // recall api after 1 sec
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/gradesSaga.js